import {
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FunctionComponent } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import UnauthenticatedLayout from "../layout/UnauthenticatedLayout";

interface Props {}

const Error: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const [searchParams] = useSearchParams();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const error = searchParams.get("title") ?? "Error";
  const errorDescription = searchParams.get("description") ?? "Unknown error.";

  const navigate = useNavigate();

  return (
    <>
      <UnauthenticatedLayout>
        <Stack
          padding={2}
          spacing={4}
          alignItems={"center"}
          textAlign={"center"}
        >
          <Typography variant={isSmallScreen ? "h4" : "h2"}>{error}</Typography>
          <Typography variant="body1">{errorDescription}</Typography>
          <Button
            variant="contained"
            size={isSmallScreen ? "small" : "medium"}
            sx={{ width: "fit-content" }}
            onClick={() => navigate("/")}
          >
            Home
          </Button>
        </Stack>
      </UnauthenticatedLayout>
    </>
  );
};

export default Error;
